import axiosService from './AxiosService';

export class FirebaseMessageRegistrationService {
   _resourceName = 'firebase-message-registration';

   async registerToken(fcmToken) {
      return await axiosService.create(`/v1.0/${this._resourceName}`, { fcmToken });
   }

   static get instance() { return firebaseMessageRegistrationService }
}

const firebaseMessageRegistrationService = new FirebaseMessageRegistrationService();

export default firebaseMessageRegistrationService;
